
import { Component, Vue } from "vue-property-decorator";
import { EMPLOYER_SERVICES_HOTJAR_SITE_ID } from "@/constants/hotjar";
import { SMHotjar } from "@/store";

SMHotjar.initHotjar(EMPLOYER_SERVICES_HOTJAR_SITE_ID);

@Component
export default class Services extends Vue {}
